import { render, staticRenderFns } from "./ProcessamentosPrognose.vue?vue&type=template&id=ccd3a70c&scoped=true"
import script from "./ProcessamentosPrognose.vue?vue&type=script&lang=js"
export * from "./ProcessamentosPrognose.vue?vue&type=script&lang=js"
import style0 from "./ProcessamentosPrognose.vue?vue&type=style&index=0&id=ccd3a70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd3a70c",
  null
  
)

export default component.exports